import React, { useContext, useEffect } from 'react';
import TestInputRadio from '../../common/radio-box';
import { useDispatch, useSelector } from 'react-redux';
import { setMockTestEditData, submitMockTest } from '../../../../actions/mock-test';
import KatexViewer from '@/helpers/Katex';
import { containsObject, updateOrInsertObject } from '@/helpers/dataHelper';
import { MockTestContext } from '..';

//single choice template
const Template4 = ({
  question,
  scrollToQ,
  section,
  model,
  answers,
  setAns,
  setAnswer,
}) => {
  const dispatch = useDispatch();
  const { testType } = useContext(MockTestContext);

  useEffect(() => {
    try {
      var elmnt = document.getElementById('q-' + scrollToQ);
      const y = elmnt.getBoundingClientRect().top + window.scrollY - 200;
      window.scroll({
        top: y,
        behavior: 'smooth',
      });
      elmnt.focus();
    } catch (err) {
      // console.log('doesnot exist');
    }
    //window.scroll(0,findPos(elmnt));
  }, [scrollToQ]);

  const answeredList = useSelector(
    (state: any) => state?.MockTestReducer?.answeredList
  );
  const option = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];

  // const countDownTime = useSelector((state: any) => state.MockTestReducer?.currentTime);
  const onAnswered = (q, ans, id) => {
    setAnswer((answers) => {
      return { ...answers, [q]: ans };
    });

    let obj = answers.find((o) => o.question_id == question.id);
    let idx = answers.findIndex((o) => o.question_id == question.id);

    //obj.answer_id= id
    setAns((prevans) => [
      ...prevans.slice(0, idx),
      { ...prevans[idx], answer_id: id },
      ...prevans.slice(idx + 1),
    ]);
    let newArr = [...answeredList];
    const newObj = {
      model: model,
      section: section,
      answer: id,
      question: question.id,
      is_correct: 'true',
    };
    if (containsObject(answeredList, newObj, 'question')) {
      newArr = updateOrInsertObject(answeredList, newObj, 'question');
    } else {
      newArr.push(newObj);
    }
    testType === 'NORMAL'
      ? dispatch(setMockTestEditData({ key: 'answeredList', value: newArr }))
      : dispatch(submitMockTest(JSON.stringify(newObj)));
  };

  return (
    <div className="mock-test-question-wrapper">
      <div className="sl-item mt-3">
        <div className="question-title-group">
          <div className="number" id={`q-${question.q_no}`}>
            {question.q_no}
          </div>
        </div>
      </div>
      <div className="type_blank">
        <div className="question-title">
          {question?.instruction ? (
            <div className="d-flex instruction-question">
              <div
                dangerouslySetInnerHTML={{ __html: question?.instruction }}
                className="px-2"
              />
            </div>
          ) : (
            ''
          )}
          {question?.image ? (
            <img
              className="img-responsive"
              style={{ width: '400px', height: '200px' }}
              src={
                'https://s3.ap-south-1.amazonaws.com/learnsic.com/media/public/' +
                question?.image
              }
            />
          ) : null}
          <p>
            {question?.has_expression ? (
              <KatexViewer text={question?.title} />
            ) : (
              question.title
            )}
          </p>
        </div>

        <ul className="list-question">
          <form>
            {question.answer.map((a, i) => (
              <TestInputRadio
                key={i}
                option={option[i]}
                onAnswered={
                  onAnswered
                  // () => {
                  //   onAnswered('q-' + question.q_no, option[i], a.id);
                  // }
                }
                question={question}
                a={a}
              />
            ))}
          </form>
        </ul>
      </div>

      {/* <ul className="list-question">
        {question.answer.map((a, i) => (
          <li>
            <span>
              <span className="lq-number">{option[i]}</span>
              <span className="my-radio">
                <input
                  type="radio"
                  name="q-1"
                  value={option[i]}
                  onChange={() => {
                    onAnswered('q-' + question.q_no, option[i], a.id);
                  }}
                />
                <label>{a.text}</label>
              </span>
            </span>
          </li>
        ))}
      </ul> */}
    </div>
  );
};

export default Template4;
